__turbopack_context__.v({
  "badgeContainer": "collection-object-module-scss-module__Nwu2FW__badgeContainer",
  "body": "collection-object-module-scss-module__Nwu2FW__body",
  "collectionObject": "collection-object-module-scss-module__Nwu2FW__collectionObject",
  "gridView": "collection-object-module-scss-module__Nwu2FW__gridView",
  "image": "collection-object-module-scss-module__Nwu2FW__image",
  "imageWrapper": "collection-object-module-scss-module__Nwu2FW__imageWrapper",
  "link": "collection-object-module-scss-module__Nwu2FW__link",
  "location": "collection-object-module-scss-module__Nwu2FW__location",
  "noImageSvg": "collection-object-module-scss-module__Nwu2FW__noImageSvg",
  "title": "collection-object-module-scss-module__Nwu2FW__title",
  "transparentBackground": "collection-object-module-scss-module__Nwu2FW__transparentBackground",
});
